exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-selector[data-v-3ed27a8a]{width:20px;height:20px}.price-selector:hover .square[data-v-3ed27a8a]{background-color:#bdbdbd}.price-selector.active .square[data-v-3ed27a8a]{background-color:#4f4f4f}.square[data-v-3ed27a8a]{width:80%;height:80%;left:50%;top:50%;transform:translate(-50%, -50%)}\n", ""]);

// exports
